<template>
    <div>
        <div>
            <UpperBar v-on:add="addLogin" v-bind:newRecord="newLogin" v-bind:addButton="addButton" v-on:searched-data="setSearchBar"/>
            <div v-show="newLogin" class="template">
                <p><span>Login: </span><b-input v-model="newUser"></b-input></p>
                <p><span>Hasło: </span><b-input v-model="newPassword"></b-input></p>
                <p><span>Użytkownik: </span><b-input v-model="newName"></b-input></p>
                <div class="showGroups"><span>Administrator: </span>
                    <button v-bind:class="[this.adminClass === true ? correct : negative]" v-on:click="setAdmin()">Tak</button>
                    <button v-bind:class="[this.adminClass === true ? negative : correct]" v-on:click="setAdmin()">Nie</button>
                </div>
                <div class="buttons">
                    <b-button class="button" v-on:click="sendPost()">Zatwierdź</b-button>
                    <b-button class="button" v-on:click="cancelAdding()">Anuluj</b-button>
                </div>
            </div>
            <div v-for="item in logins" :key="item._id">
                <div v-show="editedItem != item._id && item.name.toLowerCase().includes(searchBar.toLowerCase())" class="template">
                    <p><span>Login: </span>{{item.user}}</p>
                    <!-- <p v-if="userData.name === item.name"><span>Hasło: </span>{{item.password}}</p> -->
                    <p><span>Użytkownik: </span>{{item.name}}</p>
                    <p><span>Administrator: </span>{{item.isAdmin === false ? 'Nie' : 'Tak'}}</p>
                    <div class="buttons" v-show="confirmation != item._id">
                        <b-button class="button" v-on:click="editLogin(item._id, item.user, item.password, item.isAdmin, item.name)">Edytuj</b-button>
                        <b-button class="button" v-on:click="delLogin(item._id)">Usuń</b-button>
                    </div>
                    <div v-if="confirmation === item._id" class="confirm">Czy napewno chcesz usunąć ten login ?
                        <b-button class="button" v-on:click="confirmDelLogin(item._id)">Tak</b-button>
                        <b-button class="button" v-on:click="cancelDelMessage()">Nie</b-button>
                    </div>
                </div>
                <div v-if="editedItem == item._id" class="template">
                    <p><span>Login: </span><b-input v-model="userToEdit"></b-input></p>
                    <p><span>Hasło: </span><b-input type="password" v-model="passwordToEdit"></b-input></p>
                    <p><span>Użytkownik: </span><b-input v-model="nameToEdit"></b-input></p>
                    <div class="showGroups"><span>Administrator: </span>
                        <button v-bind:class="[adminToUpdate === true ? correct : negative]" v-on:click="updateAdmin()">Tak</button>
                        <button v-bind:class="[adminToUpdate === true ? negative : correct]" v-on:click="updateAdmin()">Nie</button>
                    </div>
                    <div class="buttons">
                        <b-button class="button" v-on:click="applyChanges(item._id, userToEdit, passwordToEdit, adminToUpdate, nameToEdit)">Zatwierdź</b-button>
                        <b-button class="button" v-on:click="cancelChanges(item._id)">Anuluj</b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import{path} from '../../../config';
import UpperBar from '../ViewElements/UpperBar';
import crypto from 'crypto';
export default {
    name: 'LoginsCMS',
    props: ['dbLogins', 'userData'],
    components: {
        UpperBar,
    },
    methods: {
        editLogin: function(id, user, password, admin, name){
            this.editedItem = id;
            this.userToEdit = user;
            this.passwordToEdit = password;
            this.nameToEdit = name;
            this.adminToUpdate = admin;   
        },
        delLogin: async function(id){
            this.confirmation = id;
            this.editedItem = '';
        },
        confirmDelLogin: async function(id){
            await axios
                .delete(`${path}login/db/${id}`)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            console.log('login deleted')
            this.$emit('shutLogins', 'Usunięto Login');
        },
        cancelChanges: function(){
            this.editedItem = '';
        },
        applyChanges: function(id, user, password, isAdmin, name){
            let hash = crypto.createHash('sha1');
            let data = hash.update(password, 'utf-8');
            let gen_hash = data.digest('hex');
            this.editedItem = '';
            const payload = {
                user: user,
                password: gen_hash,
                name: name,
                isAdmin: isAdmin
            } 
            axios
                .put(`${path}login/db/${id}`, payload)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            this.passwordToEdit = gen_hash;
            this.changeLogins(id);
        },
        changeLogins: function(id){
            for(let item of this.logins){
                if(item._id === id){
                    item.user = this.userToEdit;
                    item.password = this.passwordToEdit;
                    item.isAdmin = this.adminToUpdate;
                    item.name = this.nameToEdit;
                }
            }
        },
        addLogin: function(){
            this.newLogin = true;
        },
        cancelAdding: function(){
            this.newLogin = false;
            this.newUser = '';
            this.newPassword = '';
            this.newName = '';
        },
        cancelDelMessage: function() {
            this.confirmation = '';
        },
        sendPost: async function(){
            let hash = crypto.createHash('sha1');
            let data = hash.update(this.newPassword, 'utf-8');
            let gen_hash = data.digest('hex');
            const payload = {
                user: this.newUser,
                password: gen_hash,
                isAdmin: this.adminClass,
                name: this.newName,
            } 
            await axios
                .post(`${path}login/new`, payload)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            this.newLogin = false;
            console.log('Login Added')
            this.$emit('shutLogins', 'Dodano nowy Login');
        },
        setAdmin: function(){
            this.adminClass = !this.adminClass;
        },
        updateAdmin: function(){
            this.adminToUpdate = !this.adminToUpdate;
        },
        setSearchBar: function(searchData){
            this.searchBar = searchData;
        },
    },
    data: function(){
        return{
           logins: this.dbLogins,
           confirmation: '',
           editedItem: '',
           userToEdit: '',
           nameToEdit: '',
           passwordToEdit: '',
           adminUpdate: '',
           newLogin: false,
           newUser: '',
           newPassword: '',
           newName: '',
           adminToUpdate: '',
           adminClass: false,
           correct: 'correct',
           negative: 'negative',
           addButton: 'Dodaj Login',
           searchBar: '',
        }
    }
}
</script>
<style lang="scss" scoped>
    .template {
        border-top: solid;
        border-bottom: solid;
        border-color: blue;
        border-width: 2px;
        border-radius: 10px;
        margin-bottom: 5px;
        text-align: left;
        padding-left: 10px;
        p{
            margin: 0;
        }
        .buttons {
            display: flex;
            justify-content: space-evenly;
            margin-bottom: 5px;
        }
        span {
            font-weight: bold;
        }
        .showGroups {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin-bottom: 5px;
            p{
                margin: 0 5px;
                padding: 0 5px;
                border: solid;
                border-width: 1px;
            }
            button {
                margin: 5px;
                border: none;
                font-family: 'Source Code Pro', monospace;
                color: white;
            }
        }
    }
    .confirm{
        background-color: red;
        margin: 10px 0;
        border-radius: 10px;
        color: white;
        padding: 0 5px;
        .button {
            margin: 5px;
        }
    }
    .correct {
        background-color: green;
    }
    .negative {
        background-color: red;
    }
</style>